import officialModel from 'data/oplu_sidebar.json';
import EventsLoggingService from 'js/EventsLoggingService';
import OPLegend from 'data/op-legend.json';
import blankLegend from 'data/blank-legend.json';
import { getHandlerFor } from 'client/utils/angular';

const {EventTypes} = EventsLoggingService;

export default function ($scope, $window, $rootScope, sidebarService) {
  $scope.officialSidebar = Object.assign({}, officialModel);

  //Turn off the dev app if it's turned on
  if ($rootScope.isDev) {
    $rootScope.$broadcast('map/setinfocontent', [$rootScope.address, 'address']);
    $rootScope.$broadcast('map/openaddresswindow');
    $rootScope.$broadcast('map/recenter');
    $rootScope.isDev = false;
    $rootScope.$broadcast('locationToggle');
  }

  if ($scope.myp_municipality == 'Toronto') {
    if ($scope.legendTitle != "op")
      $rootScope.$broadcast('map/setlegend', [OPLegend, "op"]);
  } else {
    if ($scope.legendTitle != "blank") {
      $rootScope.$broadcast('map/setlegend', [blankLegend, "blank"]);
    }
  }

  $scope.EVENT_ORIGIN_PDF = EventTypes.CLICKED_LINK_OFFICIAL_PLAN_MAP_PDF;
  $scope.EVENT_ORIGIN_PLAN_REF = EventTypes.CLICKED_LINK_OFFICIAL_PLAN_REFERENCE;

  const update = ({ officialplan, secondaryplan }) => {
    $scope.officialSidebar.officialInfo.devError = "";//Holds message for when there is no dev summary
    $scope.officialSidebar.officialInfo.policyError = "";//Holds message for where there is no policy
    $scope.officialSidebar.officialInfo.policySecond = [];//Holds information for when there is secondary policy list
    $scope.lastDesc = "";//Holds value of last designation to be used for comparison.
    //Check if there is Official Plan Information

    if ('no_result' in officialplan) {
      //There is no officialplan
      $scope.officialOn = false;
      $scope.officialSidebar.officialInfo.error = officialplan.no_result;

      if ($scope.myp_municipality != 'Toronto') {
        $scope.officialSidebar.officialInfo.error = "Our Platform currently does not provide information in this area.";
      };

    } else if ('error' in officialplan) {
      //There is no officialplan
      $scope.officialOn = false;

      $scope.officialSidebar.officialInfo.error = officialplan.error;
    } else {
      //There is officialplan
      $scope.officialOn = true;
      //Set the officialplan information
      $scope.officialSidebar.officialInfo = officialplan;

      var dev_num = $scope.createArray($scope.officialSidebar.officialInfo.length);
      var dev_sum_total = 0;

      var policy_num = $scope.createArray($scope.officialSidebar.officialInfo.length);
      var policy_sum_total = 0;

      $scope.map_urls = [];

      //Determine which op's are the same
      for (var i = 0; i < $scope.officialSidebar.officialInfo.length; i++) {
        // console.log($scope.officialSidebar.officialInfo[i].myp_map_url.length);
        if ($scope.lastDesc == $scope.officialSidebar.officialInfo[i].myp_type_description) {
          //Same land designation found, time to consolidate, the last myp_type_description is the same

          //Check if the map urls are different
          if ($scope.officialSidebar.officialInfo[i].myp_map_url != $scope.officialSidebar.officialInfo[i - 1].myp_map_url) {
            if ($scope.map_urls.length == 0) {
              $scope.map_urls.push($scope.officialSidebar.officialInfo[i - 1].myp_map_url);
            }
            $scope.map_urls.push($scope.officialSidebar.officialInfo[i].myp_map_url);
            $scope.officialSidebar.officialInfo[i - 1].myp_map_url = $scope.map_urls;
            $scope.officialSidebar.officialInfo.splice(i, 1);
            console.log($scope.officialSidebar.officialInfo[i - 1].myp_map_url[0]);
          }
        } else {
          $scope.lastDesc = $scope.officialSidebar.officialInfo[i].myp_type_description;
        }
      }

      //Break the myp_policy_summary1 into an array & myp_policy_summary into an array
      for (i = 0; i < $scope.officialSidebar.officialInfo.length; i++) {
        $scope.hasInfo = $scope.createArray($scope.officialSidebar.officialInfo.length);
        $scope.hasPolicyInfo = $scope.createArray($scope.officialSidebar.officialInfo.length);

        //Add index data to array
        $scope.officialSidebar.officialInfo[i].index = i;

        //Add length of each op to array
        dev_num[i] = $scope.officialSidebar.officialInfo[i].myp_policy_summary1.length;

        //Add length of each op to array
        policy_num[i] = $scope.officialSidebar.officialInfo[i].myp_policy_summary.length;

        //Check if Dev Sum is null
        if ($scope.officialSidebar.officialInfo[i].myp_policy_summary1 == null) {
          $scope.officialSidebar.officialInfo.devError = "Area Not Covered."
        } else {
          //Dev. Sum. info
        }

        //Check if Policy Sum is null
        if ($scope.officialSidebar.officialInfo[i].myp_policy_summary == null) {
          $scope.officialSidebar.officialInfo.policyError = "Area Not Covered."
        } else {
          //Policy Sum. info
        }
      }

      for (var j = 0; j < dev_num.length; j++) {
        dev_sum_total = dev_sum_total + dev_num[j];
      }

      for (var j = 0; j < policy_num.length; j++) {
        policy_sum_total = policy_sum_total + policy_num[j];
      }

      //Declare Show More arrays for Development Summary
      $scope.infoShown = $scope.createArray($scope.officialSidebar.officialInfo.length, dev_sum_total);
      $scope.infoSize = $scope.createArray($scope.officialSidebar.officialInfo.length, dev_sum_total);

      //Declare Show More arrays for Policies Summary
      $scope.infoPolicyShown = $scope.createArray($scope.officialSidebar.officialInfo.length, policy_sum_total);
      $scope.infoPolicySize = $scope.createArray($scope.officialSidebar.officialInfo.length, policy_sum_total);

      if (!('error' in officialplan) || !('no_result' in officialplan)) {
        $scope.officialLink = function (url, source) {
          EventsLoggingService.clickedLink(source);
          $window.open(url, '_blank');
        };

        //Set the limit for the list dynamically (op) [development summary]
        $scope.infoLimit = function (index,parent) {
          if($scope.infoShown[parent][index] === undefined) {
            $scope.infoShown[parent][index] = 1;
            $scope.infoSize[parent][index] = 3;
            $scope.hasInfo[parent] = true;

            return $scope.infoSize[parent][index];
          } else {
            return $scope.infoSize[parent][index] * $scope.infoShown[parent][index];
          }
        };

        //Check if there is more info to show (op) [development summary]
        $scope.hasMoreInfoToShow = function (index,parent) {
          if($scope.infoShown[parent][index] === undefined) {
            return 1 < ($scope.officialSidebar.officialInfo[parent].myp_policy_summary1[index].items.length / 1);
          } else {
            return $scope.infoShown[parent][index] < ($scope.officialSidebar.officialInfo[parent].myp_policy_summary1[index].items.length / $scope.infoShown[parent][index]);
          }
        };

        //Show more information (op) [development summary]
        $scope.showMoreInfo = function(index,parent){
          $scope.infoShown[parent][index] = $scope.officialSidebar.officialInfo[parent].myp_policy_summary1[index].items.length;
          $scope.hasInfo[parent] = $scope.hasMoreInfoToShow(index,parent);
        };

        //Set the limit for the list dynamically (op) [policies summary]
        $scope.infoPolicyLimit = function (index,parent) {
          if($scope.infoPolicyShown[parent][index] === undefined) {
            $scope.infoPolicyShown[parent][index] = 1;
            $scope.infoPolicySize[parent][index] = 3;
            $scope.hasPolicyInfo[parent] = true;

            return $scope.infoPolicySize[parent][index];
          } else {
            return $scope.infoPolicySize[parent][index] * $scope.infoPolicyShown[parent][index];
          }
        };

        //Check if there is more info to show (op) [policies summary]
        $scope.hasMorePolicyInfoToShow = function (index,parent) {
          if($scope.infoPolicyShown[parent][index] === undefined) {
            return 1 < ($scope.officialSidebar.officialInfo[parent].myp_policy_summary[index].items.length / 1);
          } else {
            return $scope.infoPolicyShown[parent][index] < ($scope.officialSidebar.officialInfo[parent].myp_policy_summary[index].items.length / $scope.infoPolicyShown[parent][index]);
          }
        };

        //Show more information (op) [policies summary]
        $scope.showMorePolicyInfo = function(index,parent){
          $scope.infoPolicyShown[parent][index] = $scope.officialSidebar.officialInfo[parent].myp_policy_summary[index].items.length;
          $scope.hasPolicyInfo[parent] = $scope.hasMorePolicyInfoToShow(index,parent);
        };
      };
    };

    //Check if there is Seconday Plan Information
    if (secondaryplan) {
      if ('no_result' in secondaryplan) {
        //There is no secondaryplan
        $scope.secondaryOn = false;
        $scope.officialSidebar.secondaryInfo.error = secondaryplan.no_result;

      } else if ('error' in secondaryplan) {
        //There is no secondaryplan
        $scope.secondaryOn = false;
        $scope.officialSidebar.secondaryInfo.error = secondaryplan.error;
      } else {
        //There is secondaryplan
        $scope.secondaryOn = true;

        $scope.officialSidebar.secondaryInfo = secondaryplan;
      }
    }

  };

  $scope.tooltip_official = {title: 'Click question mark for source', checked: true};

  if (!$scope.isSearchBar) {
    //reset official on/off button if needed.
    $scope.officialSidebar.official[0].toggle = $scope.checkLayer($scope.officialSidebar.official[0].name);

    //reset secondary on/off button if needed.
    $scope.officialSidebar.secondary[0].toggle = $scope.checkLayer($scope.officialSidebar.secondary[0].name);

    if (!$scope.onSidebar || $rootScope.initSidebar == false) {
      sidebarService.sidebarInfo({
        type: "officialplan_sidebar",
        gid: $scope.sidebar.gid,
        myp_municipality: $scope.sidebar.myp_municipality
      }).success(update);
      $rootScope.initSidebar = true;
    }
  }

  $scope.officialOn = false;
  $scope.secondaryOn = false;

  const toggle = (status) => {
    $scope.officialSidebar.official[0].toggle = status;
    $scope.officialSidebar.secondary[0].toggle = status;
  };

  const reset = () => {
    $scope.officialSidebar = Object.assign({}, officialModel);
    $scope.officialOn = false;
    $scope.secondaryOn = false;
  };

  $rootScope.$on('sidebar/official/update', getHandlerFor(update));
  $rootScope.$on('sidebar/official/toggle', getHandlerFor(toggle));
  $rootScope.$on('sidebar/official/reset', getHandlerFor(reset));

  return {
    update,
    toggle,
    reset
  };
};



// WEBPACK FOOTER //
// ./client/controllers/oplu_sidebar.js